"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSalesOrderDetailsForStatus = void 0;
const react_1 = require("react");
const SalesOrder_1 = require("../models/SalesOrder");
const constants_1 = require("../helpers/constants");
const labels_1 = require("../types/labels");
const useConfig_1 = require("../../../../hooks/useConfig");
const TSalesOrderType_1 = require("../types/TSalesOrderType");
const useSalesOrderDetailsForStatus = (salesOrder) => {
    const { baseLocationImageUrl } = (0, useConfig_1.useConfig)();
    const { status, completed, type } = salesOrder;
    const statusSteps = (0, react_1.useMemo)(() => {
        if (!salesOrder) {
            return null;
        }
        return constants_1.salesOrderStatusSteps.get(salesOrder.type);
    }, [constants_1.salesOrderStatusSteps, salesOrder]);
    const doesDeliveryTrackingLinkExist = (0, react_1.useMemo)(() => {
        const { externalDeliveryTrackingUrl } = salesOrder;
        // check if the delivery tracking URL exists
        return (externalDeliveryTrackingUrl === null || externalDeliveryTrackingUrl === void 0 ? void 0 : externalDeliveryTrackingUrl.length) > 0;
    }, [salesOrder.externalDeliveryTrackingUrl]);
    const isDeliveryDriverAssigned = (0, react_1.useMemo)(() => {
        var _a;
        const { deliveryDriver } = salesOrder;
        // check if the driver's name is populated
        return ((_a = deliveryDriver === null || deliveryDriver === void 0 ? void 0 : deliveryDriver.name) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }, [salesOrder.deliveryDriver]);
    const statusesCount = (0, react_1.useMemo)(() => {
        if (!statusSteps) {
            return 0;
        }
        return statusSteps.size;
    }, [statusSteps]);
    const currentStatusStep = (0, react_1.useMemo)(() => {
        if (!salesOrder) {
            return 0;
        }
        return statusSteps.get(salesOrder.status);
    }, [statusSteps, salesOrder]);
    const statusProgress = (0, react_1.useMemo)(() => {
        if (!salesOrder) {
            return "100%";
        }
        if (salesOrder.status === SalesOrder_1.TSalesOrderStatus.Pending ||
            salesOrder.completed) {
            return "100%";
        }
        return `${((currentStatusStep / statusesCount) * 100).toFixed(2)}%`;
    }, [salesOrder, currentStatusStep, statusesCount]);
    const statusBackgroundImage = (0, react_1.useMemo)(() => {
        if (!salesOrder) {
            return baseLocationImageUrl;
        }
        return (0, constants_1.getBackgroundImageForOrderStatus)(salesOrder.status);
    }, [constants_1.getBackgroundImageForOrderStatus, salesOrder]);
    const statusText = (0, react_1.useMemo)(() => {
        if (!salesOrder) {
            return "";
        }
        return (0, labels_1.getCustomerTextForOrderStatus)(salesOrder.status, salesOrder.type);
    }, [labels_1.getCustomerTextForOrderStatus, salesOrder]);
    const deliveryDriverStatusText = (0, react_1.useMemo)(() => {
        if (type === TSalesOrderType_1.TSalesOrderType.Pickup) {
            return "";
        }
        const baseDeliveryText = constants_1.text[constants_1.TTheme.Zam][constants_1.TOrderingText.Delivery];
        // this one need to be called before DriverCompleted
        // the reason is that a refunded order will also be marked as "completed"
        if (status === SalesOrder_1.TSalesOrderStatus.Cancelled ||
            status === SalesOrder_1.TSalesOrderStatus.Refunded) {
            return baseDeliveryText[constants_1.TDeliveryText.DriverCancelled];
        }
        if (completed) {
            return baseDeliveryText[constants_1.TDeliveryText.DriverCompleted];
        }
        if (isDeliveryDriverAssigned) {
            return baseDeliveryText[constants_1.TDeliveryText.DeliveryPartnerAssigned];
        }
        // if we have no tracking link/driver assigned, display a generic message on delivering status
        if (status === SalesOrder_1.TSalesOrderStatus.Delivering) {
            return baseDeliveryText[constants_1.TDeliveryText.DriverAssigned];
        }
        return baseDeliveryText[constants_1.TDeliveryText.DriverPending]; // self delivery
    }, [status, completed, type, isDeliveryDriverAssigned]);
    return (0, react_1.useMemo)(() => ({
        statusesCount,
        currentStatusStep,
        statusProgress,
        statusBackgroundImage,
        statusText,
        deliveryDriverStatusText,
        doesDeliveryTrackingLinkExist,
        isDeliveryDriverAssigned
    }), [
        statusesCount,
        currentStatusStep,
        statusProgress,
        statusBackgroundImage,
        statusText,
        deliveryDriverStatusText,
        doesDeliveryTrackingLinkExist,
        isDeliveryDriverAssigned
    ]);
};
exports.useSalesOrderDetailsForStatus = useSalesOrderDetailsForStatus;
//# sourceMappingURL=useSalesOrderDetailsForStatus.js.map